<template>
  <div
    :class="[
      'py-1 px-2 d-flex justify-content-center align-items-center',
      $style.leagueNameWrapper,
      $style.nowrap
    ]"
  >
    <b-img
      :src="image"
      :class="$style.leagueLogo"
      class="mr-1"
    />
    <div class="pl-2 d-flex flex-column flex-sm-row">
      <strong>{{ leagueName }}</strong>
      <span>
        <span class="d-none d-sm-inline">&nbsp;-</span>
        {{ roundName }}
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TheRoundTitle',
  props: {
    image: {
      type: String,
      required: true,
      default: null,
    },
    leagueName: {
      type: String,
      required: true,
      default: null,
    },
    roundName: {
      type: String,
      required: true,
      default: null,
    },
  },
}
</script>

<style module lang="scss">
  @import '../../assets/scss/variables';
  .leagueNameWrapper {
    .leagueLogo {
      max-width: 40px;
      max-height: 40px;
    }
  }
  .nowrap{
    white-space: nowrap;
  }
</style>
